import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'
import './gp-web-plans.css'

export default class GPWebPlans extends Component {
  render() {
    const { t, plan1Handler, plan2Handler, location } = this.props;

    /* eslint-disable */
    return (
      <div className="plans">
        <div className="plans__content">
          <div className="plans__plan">
            <p className="plans__title">{t('GP_PLAN_1_TITLE')}</p>
            <ul className='plans__list plans__list_checked'>
              <li className='plans__list_item'>{t('GP_PLAN_1_BULLET_1')}</li>
              <li className='plans__list_item'>{t('GP_PLAN_1_BULLET_2')}</li>
            </ul>
            <div className='plans__cta'>
              <Link
                  to={`/gp-web/plans-checkout${location.search}`}
                  onClick={plan1Handler}
                  className="button-primary plans__plan_link xs-block xs-text-center xs-border-none xs-pt1 xs-text-white xs-col-12 xs-text-7 disabled"
                >
                  {t("GP_PLAN_1_CTA")}
                </Link>
            </div>
          </div>
          <div className="plans__plan">
            <p className="plans__title">{t('GP_PLAN_2_TITLE')}</p>
            <ul className='plans__list'>
              <li className='plans__list_item'>{t('GP_PLAN_2_BULLET_1')}</li>
            </ul>
            <div className='plans__cta'>
              <button className='button-primary xs-border-none xs-pt1 xs-text-white xs-col-12 xs-text-7' onClick={plan2Handler}>{t('GP_PLAN_2_CTA')}</button>
            </div>
          </div>
        </div>

      </div>
    )
    /* eslint-enable */
  }
}

GPWebPlans.propTypes = {
  t: PropTypes.func.isRequired,
  plan1Handler: PropTypes.func.isRequired,
  plan2Handler: PropTypes.func.isRequired,
}

GPWebPlans.defaultProps = {
}




// WEBPACK FOOTER //
// ./src/components/gp-web-plans/gp-web-plans.js